import type { Nullable } from '../shared/Nullable';
import { Language } from './Language';

export class LanguageParser {
	private constructor() {}

	static readonly DEFAULT_LANGUAGE = Language.ES;

	private static readonly VALUES: readonly Language[] = Object.values(Language);

	private static readonly LANGUAGE_CODE_LENGTH = 2;

	static parse(value: Nullable<string>): Nullable<Language> {
		if (value == null) {
			return null;
		}

		const normalized = value.trim().toUpperCase();
		return LanguageParser.VALUES.find((language) => language === normalized) ?? null;
	}

	static fromLocale(locale: string): Language {
		const languageCode = locale.trim().slice(0, LanguageParser.LANGUAGE_CODE_LENGTH);
		return LanguageParser.parse(languageCode) ?? LanguageParser.DEFAULT_LANGUAGE;
	}
}
